/**
 * @generated SignedSource<<68c2d76fc652255136da42e880f09dbf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UploadBankStatementInput = {
  coveredUntil?: any | null | undefined;
  id: string;
  upload: UploadInput;
};
export type UploadInput = {
  data: string;
  filename: string;
  lastModifiedAt: any;
};
export type UploadBankStatementDialogMutation$variables = {
  input: UploadBankStatementInput;
};
export type UploadBankStatementDialogMutation$data = {
  readonly uploadBankStatement: {
    readonly balanceAtLastBookingDate: number;
    readonly bankAccount: {
      readonly coveredUntil: any | null | undefined;
      readonly currentBalance: number;
      readonly id: string;
      readonly lastUpload: {
        readonly bookingCount: number;
        readonly coveredUntil: any;
        readonly firstBookingDate: any;
        readonly lastBookingDate: any;
        readonly uploadedAt: any;
        readonly uploadedBy: string;
      } | null | undefined;
    };
    readonly bookingCount: number;
    readonly coveredUntil: any;
    readonly firstBookingDate: any;
    readonly lastBookingDate: any;
    readonly otherShareOfOutgoing: number | null | undefined;
  };
};
export type UploadBankStatementDialogMutation = {
  response: UploadBankStatementDialogMutation$data;
  variables: UploadBankStatementDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstBookingDate",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastBookingDate",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "coveredUntil",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bookingCount",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BankStatementUploadResult",
    "kind": "LinkedField",
    "name": "uploadBankStatement",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "balanceAtLastBookingDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "otherShareOfOutgoing",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BankAccount",
        "kind": "LinkedField",
        "name": "bankAccount",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currentBalance",
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BankStatementUpload",
            "kind": "LinkedField",
            "name": "lastUpload",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uploadedBy",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uploadedAt",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UploadBankStatementDialogMutation",
    "selections": (v5/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UploadBankStatementDialogMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "6bc18bbed5a9bf3027d61cbf3c45feca",
    "id": null,
    "metadata": {},
    "name": "UploadBankStatementDialogMutation",
    "operationKind": "mutation",
    "text": "mutation UploadBankStatementDialogMutation(\n  $input: UploadBankStatementInput!\n) {\n  uploadBankStatement(input: $input) {\n    firstBookingDate\n    lastBookingDate\n    coveredUntil\n    bookingCount\n    balanceAtLastBookingDate\n    otherShareOfOutgoing\n    bankAccount {\n      id\n      currentBalance\n      coveredUntil\n      lastUpload {\n        firstBookingDate\n        lastBookingDate\n        coveredUntil\n        bookingCount\n        uploadedBy\n        uploadedAt\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6c0920ba68bd0f8b9b07ae93469633f3";

export default node;
